module.exports = __webpack_public_path__ + "media/12_30.659c3e53.wav";